export function formatDate(value, options = {}) { if (!value)
    return value; const date = new Date(value); const { locale = 'es-CL', ...dateTimeFormatOptions } = options; const formatter = new Intl.DateTimeFormat(locale, dateTimeFormatOptions); return formatter.format(date); }
